<template>
  <ul class="navbar-nav flex sidebar accordion" id="accordionSidebar">
    <SideItem pageid="Dashboard" />
    <hr>
    <div class="sidebar-heading">会員管理</div>
    <SideItem pageid="Members" />
    <SideItem pageid="KakinLog" />
    <SideItem pageid="KmailLog" />
    <SideItem pageid="PaymentLog" />
    <SideItem pageid="Payupdate" />
    <hr>
    <div class="sidebar-heading">山管理</div>
    <SideItem pageid="Mountains" />
    <SideItem pageid="MountainArea" />
    <hr>
    <div class="sidebar-heading">お知らせ</div>
    <SideItem pageid="News1" />
    <SideItem pageid="News2" />
    <SideItem pageid="News" />
    <SideItem pageid="Typhoon" />
    <hr>
    <div class="sidebar-heading">メール配信</div>
    <SideItem pageid="Maillog" />
    <SideItem pageid="Fcstmail" />
    <SideItem pageid="Stormmail" />
    <SideItem pageid="Recommendmail" />
    <SideItem pageid="Weekmail" />
    <hr>
    <div class="sidebar-heading">コラム関係</div>
    <SideItem pageid="Characteristic" />
    <hr>
    <div class="sidebar-heading">マスタ管理</div>
    <SideItem pageid="Livecamera" />
    <hr>
    <template v-if="$store.state.auth.roles.indexOf('admin') >= 0">
      <div class="sidebar-heading">管理者専用</div>
      <SideItem pageid="Users" />
    </template>
  </ul>
</template>
<script>
import SideItem from '@/components/adminparts/SideItem.vue'

export default {
  name: 'SideBar',
  components: { SideItem },
  methods: {
    isActive (name) {
      return this.$store.state.activeItem === name ? ' active' : ''
    }
  }
}
</script>

<style scoped>
.sidebar {
  background-color: rgb(56, 56, 56);
  box-shadow: 0 2px 10px rgba(0,0,0,0.8);
}
hr{
  margin: 0 1rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.sidebar .sidebar-heading {
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 80%;
  color: rgba(255, 255, 255, 0.4);

}
</style>



// WEBPACK FOOTER //
// src/components/admin/SideBar.vue